<template>
  <div id="ag-grid-demo">
    <vs-popup class="holamundo" title="New Doctor" :active.sync="popupActivo">
      <vs-alert
        color="danger"
        icon-pack="feather"
        icon="icon-info"
        v-for="(errors, err) in errorMessage"
        v-bind:key="err"
      >
        <span>{{ errors }}</span>
      </vs-alert>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-7/12">
          <div class="vx-row mb-4">
            <div class="vx-col sm:w-1/3 topPad">
              <span class="popup_lbl inputStyles">Doctor</span>
            </div>
            <div class="vx-col sm:w-1/2">
              <vs-input
                class="inputx"
                v-validate="'required|max:30'"
                name="Doctor Name"
                v-model="form.doctorName"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('Doctor Name')"
                >{{ errors.first("Doctor Name") }}</span
              >
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 topPad">
              <span class="popup_lbl inputStyles">Degree</span>
            </div>
            <div class="vx-col sm:w-1/2">
              <vs-input
                class="inputx"
                v-validate="'required|max:45'"
                name="Degree"
                v-model="form.degree"
              />
              <span class="text-danger text-sm" v-show="errors.has('Degree')">{{
                errors.first("Degree")
              }}</span>
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 topPad">
              <span class="popup_lbl inputStyles">Department</span>
            </div>
            <div class="vx-col sm:w-1/2">
              <select
                v-model="form.departmentId"
                v-validate.lazy="'required'"
                name="Department"
                class="vs-select--input department-select"
                style="height: 36px"
              >
                <option
                  class="vs-component"
                  v-for="(item, index) in departments"
                  v-bind:key="index"
                  :value="item.id"
                >
                  {{ item.name }}
                </option>
              </select>

              <span
                class="text-danger text-sm"
                v-show="errors.has('Department')"
                >{{ errors.first("Department") }}</span
              >
            </div>
          </div>
        
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/3 topPad">
              <span class="popup_lbl inputStyles">PhoneNo</span>
            </div>
            <div class="vx-col sm:w-1/2">
              <vs-input
                class="inputx"
                v-validate="'numeric|min:10|max:11'"
                name="PhoneNo"
                v-model="form.phoneNo"
              />
              <span
                class="text-danger text-sm"
                v-show="errors.has('PhoneNo')"
                >{{ errors.first("PhoneNo") }}</span
              >
            </div>
          </div>

         
        </div>
        <div class="vx-col sm:w-4/12 w-full text-center">
          <label
            style="font-weight: 500; font-size: 16px; color: rgb(67, 65, 65)"
            >Doctor Image</label
          ><br />
          <div v-if="form.imageUrl" class="image-preview">
            <img
              :src="form.imageUrl"
              alt="Doctor Image"
              class="doctor-image"
              width="120"
              height="120"
            />
          </div>
         
          <div class="file-input-wrapper">
            <input
              ref="doctorImageInput"
              id="doctorImageInput"
              v-validate="'ext:jpg,jpeg,png'"
              name="DoctorImage"
              type="file"
              accept="image/*"
              @change="selectDoctorImage"
              class="choose-file-input"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('DoctorImage')"
            >
              {{ errors.first("DoctorImage") }}
            </span>
          </div>
          <div class="vx-row mt-4" style="margin-left: 20px">
            <div
              class="vx-col"
              style="display: flex; align-items: center; gap: 5px"
            >
              <input
                type="checkbox"
                v-model="form.status"
                id="activeCheckbox"
              />
              <label for="activeCheckbox">Active</label>
            </div>
            <div
              class="vx-col"
              style="display: flex; align-items: center; gap: 5px"
            >
              <input
                type="checkbox"
                v-model="form.autoScheduleActive"
                id="autoScheduleCheckbox"
              />
              <label for="autoScheduleCheckbox">Auto Schedule</label>
            </div>
          </div>
        </div>

        <!-- Billing Table -->
        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <h4 class="table-heading">Default Fees</h4>
          </div>
        </div>

        <div class="vx-row mb-6">
          <div class="vx-col w-full">
            <table class="fees-table">
              <thead>
                <th style="width: 9%">SiNo</th>
                <th style="width: 40%">Description</th>
                <th style="width: 10%">Qty</th>
                <th style="width: 15%">Amount</th>
                <!-- <th style="width:9%">Amount</th>-->
                <th v-if="readonlyFlag == false" style="width: 5%">&nbsp;</th>
              </thead>
              <tbody v-if="BillData.billItems.length == 0">
                <tr>
                  <td colspan="5">
                    <vs-alert
                      active="true"
                      color="warning"
                      style="text-align: center"
                    >
                      <span>No Bills</span>
                    </vs-alert>
                  </td>
                </tr>
              </tbody>
              <tbody v-if="BillData.billItems.length != 0">
                <tr
                  v-for="(bill, index) in BillData.billItems"
                  v-bind:key="index"
                >
                  <td>
                    <vs-input
                      v-model="bill.slNo"
                      style="width: 100%"
                      class="configclass"
                      tabindex="-1"
                      readonly
                    ></vs-input>
                  </td>
                  <td>
                    <select
                      v-model="bill.billItemId"
                      class="vs-select--input myselect"
                      style="height: 36px; width: 100%"
                      @change="getBillItemDetails(bill.billItemId, index)"
                    >
                      <option
                        v-for="(item, index) in billItems"
                        v-bind:key="index"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <vs-input
                      :readonly="readonlyFlag"
                      v-model="bill.qty"
                      class="configclass"
                      style="width: 100%"
                    ></vs-input>
                  </td>
                 
                  <td>
                    <vs-input
                      v-model="bill.rate"
                      class="configclass"
                      style="width: 100%"
                      @keydown.tab="insertRow(index)"
                    />
                  </td>

                  <td
                    v-if="readonlyFlag == false"
                    style="text-align: right; padding-right: 20px"
                    title="delete"
                  >
                    <feather-icon
                      icon="Trash2Icon"
                      class="mr-0 cursor-pointer"
                      style="color: #ff0000"
                      @click="deleteRow(index)"
                    ></feather-icon>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="vx-row mb-4 popup_btn">
        <vs-button
          color="primary"
          ref="loadableButton"
          type="relief"
          style="margin-right: 5px"
          @click="saveDoctor"
          id="button-with-loading"
          class="float-center vs-con-loading__container"
          >Save</vs-button
        >
        <vs-button
          color="primary"
          type="border"
          style="margin-left: 5px"
          @click="clearFields"
          >Clear</vs-button
        >
      </div>
    </vs-popup>
    <vx-card>
      <div class="vx-row card-header-row">
        <div>
          <vs-button color="success" type="border" @click="openForm">
            New
          </vs-button>
        </div>

        <div>
          <feather-icon
            icon="XIcon"
            class="custom-class"
            style="width: 20px; height: 20px; color: #009696; cursor: pointer"
            title="Close"
            @click="exit"
          />
        </div>
      </div>

      <vue-good-table
        mode="remote"
        :rows="contacts"
        :columns="vgColumns"
        :totalRows="totalRecords"
        :pagination-options="{ enabled: true, perPage: 7 }"
        :sort-options="{ enabled: false }"
        :isLoading.sync="isLoading"
        @on-page-change="onPageChange"
        @on-column-filter="onColumnFilter"
        @on-row-dblclick="onRowDoubleClick" 
        styleClass="vgt-table condensed"
      >  <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field === 'activeFlag'">
      <span v-if="props.row.activeFlag === 'Y'" style="color: green;">
        Active
      </span>
      <span v-else style="color: red;">
        Inactive
      </span>
    </span>

    <span v-else>
      {{ props.formattedRow[props.column.field] }}
    </span>
  </template>
  </vue-good-table>
    </vx-card>
  </div>
</template>

<script>
import { EditIcon } from "vue-feather-icons";

export default {
  components: {
    EditIcon,
  },
  data() {
    return {
      BillData: {
        billItems: [
          {
            slNo: 1,
            billItemId: 0,
            billItem: "",
            qty: "1",
            rate: "",

            taxId: 0,
            taxAmount: "",
            gstValue: "",
          },
        ],
      },
      billItems: [
        {
          id: 0,
          name: "Select",
        },
      ],
      errorMessage: [],
      readonlyFlag: false,
      popupActivo: false,
      uploaded: false,
      isLoading: false,
      form: {
        doctorName: "",
        degree: "",
        mobileNo: "",
        phoneNo: "",
        address: "",
        file: "",
        doctorId: "",
        departmentId: "",
        imageUrl: null,
        status: true,
        autoScheduleActive: true,
      },
      departments: [
        {
          id: "",
          name: "Select",
        },
      ],
      searchTerm: "",
      serverParams: {
        companyId: this.$session.get("companyId"),
        filter: {},
        currentPage: 1,
        limit: 7,
      },
      totalRecords: 0,

      vgColumns: [
        { label: "DOCTOR", field: "doctor", filterOptions: { enabled: true } },
        { label: "DEGREE", field: "degree", filterOptions: { enabled: true } },
        {
          label: "PHONE NO",
          field: "phoneNo",
          filterOptions: { enabled: true },
        },
        {
          label: "DEPARTMENT",
          field: "department",
          filterOptions: { enabled: true },
        },
          {
        label: "STATUS",
        field: "activeFlag",
      },
      ],
      contacts: [{}],
    };
  },

  mounted() {
    this.getbillItems();
    this.loadDoctors();
    this.getDepartments();
  },
  methods: {
    getbillItems() {
      var request = {
        companyId: this.$session.get("companyId"),
        types: ["clinic"],
      };

      this.$http
        .post("getbillitems", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.billItems = response.data.data.map((x) => ({
            id: x.item.id,
            name: x.item.name,
            amount: x.amount,
          }));
        });
    },
    getBillItemDetails(selectedItemId, index) {
      const selected = this.billItems.find((x) => x.id === selectedItemId);

      if (selected) {
        this.BillData.billItems[index].billItem = selected.name;
        this.BillData.billItems[index].rate = selected.amount;
        this.BillData.billItems[index].qty = 1;
      }
    },

    insertRow(index) {
      if (this.BillData.billItems.length == index + 1) {
        var newrow = {
          slNo: this.BillData.billItems.length + 1,
          billItemId: 0,
          qty: "",
          rate: "",
          // "amount": "",
          taxId: 1,
          taxAmount: "",
          gstValue: "",
        };
        this.BillData.billItems.push(newrow);
        this.$emit("rows-updated");
      }
    },
    deleteRow(deleteRowIndex) {
      if (deleteRowIndex > 0) {
        this.$delete(this.BillData.billItems, deleteRowIndex);

        //this.showTotal();
        this.$emit("rows-updated");
      }
    },
    selectDoctorImage(e) {
      const file = e.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.form.imageUrl = reader.result; // Base64 string
      };
    },

    loadDoctors() {
      this.isLoading = true;

      this.$http
        .post("getDoctorDashboard", JSON.stringify(this.serverParams), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          this.contacts = response.data.data.records;
          this.totalRecords = response.data.data.recordsTotal;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    onPageChange(params) {
      this.serverParams.currentPage = params.currentPage;
      this.loadDoctors();
    },

    onColumnFilter(params) {
      const f = params.columnFilters;

      let filterObj = {};

      if (f.doctor) {
        filterObj.doctor = {
          filter: f.doctor,
          type: "contains",
        };
      }

      if (f.degree) {
        filterObj.degree = {
          filter: f.degree,
          type: "contains",
        };
      }

      if (f.phoneNo) {
        filterObj.phoneNo = {
          filter: f.phoneNo,
          type: "equals",
        };
      }

      if (f.department) {
        filterObj.department = {
          filter: f.department,
          type: "contains",
        };
      }

      this.serverParams.filter = filterObj;
      this.loadDoctors();
    },

    getDepartments() {
      this.$http
        .post("getdoctordepartments", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          response.data.data.forEach((value) => {
            this.departments.push(value);
          });
        });
    },
    getDoctorDetail(doctorId) {
      this.errors.clear();
   
      var request = {
        companyId: this.$session.get("companyId"),
         doctorId: doctorId,
      };

      this.$http
        .post("getDoctorDetail", JSON.stringify(request), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.form = response.data.data;
          if (this.form.imageUrl) {
            const baseUrl = this.form.imageUrl.split("?")[0];
            this.form.imageUrl = `${baseUrl}?v=${Date.now()}`;
          }

          if (this.form.file) {
            this.uploaded = true;
          } else {
            this.uploaded = false;
          }
          this.popupActivo = true;
        });
      this.getDoctorCharges(selectedDoctorId);
    },
    onRowDoubleClick(params) {
  this.getDoctorDetail(params.row.doctorId);
},
    getDoctorCharges(doctorId) {
      const request = {
        companyId: this.$session.get("companyId"),
        doctorId: doctorId,
      };

      this.$http
        .post("v2/getDefaultDoctorCharges", JSON.stringify(request), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          const charges = response.data.data || [];

          if (charges.length > 0) {
            this.BillData.billItems = charges.map((item, i) => ({
              slNo: i + 1,
              billItemId: item.itemId,
              billItem: item.billItem,
              qty: 1,
              rate: item.price,
              //amount: parseFloat(item.price) * 1,
              taxId: parseInt(item.taxId),
              taxAmount: item.taxAmount,
              //gstValue: "",
              //readonly: true, // if you want to lock editing
            }));
          } else {
            // if no saved charges, keep 1 blank row
            this.BillData.billItems = [
              {
                slNo: 1,
                billItemId: 0,
                qty: "",
                rate: "",
                //amount: "",
                taxId: "",
                taxAmount: "",
                gstValue: "",
              },
            ];
          }
        });
    },

    openForm() {
      this.errors.clear();
      this.clearFields();
      this.popupActivo = true;
      this.uploaded = false;
      this.errorMessage = [];
      this.closeLoading();
      this.$nextTick(() => {
        this.$validator.reset();
      });
    },
    openLoading() {
      document.getElementById("button-with-loading").disabled = true;
      this.$vs.loading({
        background: "primary",
        color: "primary",
        container: "#button-with-loading",
        scale: 0.45,
      });
    },
    exit() {
      this.$router.push("/Master");
    },

    closeLoading() {
      document.getElementById("button-with-loading").disabled = false;
      this.$vs.loading.close("#button-with-loading > .con-vs-loading");
    },
    saveDoctor() {
      // this.openLoading();
      //  this.errorMessage = [];
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          const billingData = this.BillData.billItems
            .filter((bill) => bill.billItemId && bill.rate) // only valid rows
            .map((bill) => ({
              itemId: bill.billItemId,
              price: bill.rate,
              taxId: bill.taxId,
              taxAmount: bill.taxAmount,
              billItem: bill.billItem,
            }));
          const doctorData = {
            doctorName: this.form.doctorName,
            degree: this.form.degree,
            mobileNo: this.form.mobileNo,
            phoneNo: this.form.phoneNo,
            address: this.form.address,
            doctorId: this.form.doctorId, 
            departmentId: this.form.departmentId,
            imageUrl: this.form.imageUrl,
            status: this.form.status,
            autoScheduleActive: this.form.autoScheduleActive,
          };

          var request = {
            companyId: this.$session.get("companyId"),
            userId: this.$session.get("userId"),
            data: doctorData,
            defaultCharges: billingData,
          };
          //  this.openLoading();
          this.$http
            .post("savedoctor", JSON.stringify(request), {
              headers: {
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              this.loadDoctors();
              this.popupActivo = false;
              this.$vs.loading.close("#button-with-loading > .con-vs-loading");
              document.getElementById("button-with-loading").disabled = false;
              this.$vs.notify({
                title: "Successfully Saved",
                color: "success",
                iconPack: "feather",
                icon: "icon-check",
                position: "top-center",
              });
            })
            .catch((error) => {
            console.error(error); 

            this.$vs.notify({
              title: "Error Occured While Saving",
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert",
              position: "top-center",
            });
          });
        } else {
         this.$vs.notify({
    title: "Validation Error",
    text: "Please fill all required fields correctly",
    color: "warning",
    iconPack: "feather",
    icon: "icon-alert-circle",
    position: "top-center",
  });
        }
      });
    },
    selectFile(e) {
      var f = e.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = () => {
        this.form.file = reader.result;
      };
    },
    clearFields() {
      this.form.doctorName = "";
      this.form.degree = "";
      this.form.mobileNo = "";
      this.form.phoneNo = "";
      this.form.address = "";
      this.form.file = "";
      this.form.doctorId = "";
      this.form.departmentId = "";
      this.form.imageUrl = null;
      this.form.status = true;
      this.form.autoScheduleActive = true;
      this.BillData = {
        billItems: [
          {
            slNo: 1,
            billItemId: 0,
            qty: "",
            rate: "",
            amount: "",
            taxId: "",
            taxAmount: "",
            gstValue: "",
          },
        ],
      };
      if (this.$refs.doctorImageInput) {
        this.$refs.doctorImageInput.value = null;
      }
    },
  },
};
</script>

<style>
.popup_lbl {
  padding-left: 10%;
}

.popup_btn {
  margin-left: 100px;
  padding-left: 98px;
}

.ag-header-cell-label {
  justify-content: center;
}
.inputStyles {
  font-size: 11.8px;
  font-weight: 600;
}
.topPad {
  padding-top: 7px;
}

.con-vs-popup.holamundo .vs-popup {
  width: 800px !important;
  height: auto !important;
  max-width: 90% !important;

  max-height: 90% !important;
}

.doctor-image {
  border-radius: 8px;
  border: none;
  margin-top: 10px;
}

.file-input-wrapper {
  margin-top: 8px; /* spacing below image */
  display: inline-block; /* keeps it inline with image width */
  text-align: left; /* optional, aligns label/input inside wrapper */
  margin-left: 15%; /* move it slightly to the right */
}

.myselect {
  width: 100% !important; /* make it match other inputs */
  max-width: 100%; /* prevent it from stretching */
  box-sizing: border-box; /* include padding in width */
}

.table-heading {
  margin-left: 20px; /* left margin */
  font-weight: 500; /* makes it look like heading */
  font-size: 16px;
  color: rgb(67, 65, 65);
}

.fees-table {
  width: calc(100% - 40px); /* table same width but inset */
  margin-left: 20px; /* align with heading */
  border-collapse: collapse;
}
.department-select {
  width: 95% !important; /* keep consistent with inputs */
  max-width: 100%;
  box-sizing: border-box;
}
.popup_btn {
  display: flex;
  justify-content: flex-start; /* keep aligned left */
  margin-left: 20%; /* tweak % until it matches your form alignment */
  gap: 10px;
}

table thead {
  background: #eaeff3;
}
.upload-btn {
  display: inline-block;
  padding: 6px 12px;
  background-color: #007bff;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.upload-btn:hover {
  background-color: #0056b3;
}
input[type="checkbox"]:focus {
  outline: none !important;
  box-shadow: none !important;
}
.card-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
}

.vgt-table thead th {
  background: white;
}

.vgt-wrap__footer {
  background: white;
}

table.vgt-table {
  font-size: 12px;
  border: none;
}

.vgt-right-align {
  text-align: left;
}

.vgt-table.condensed tr {
  height: 56px;
}

.vgt-table.condensed td {
  padding-top: 19px;
}

.vgt-input {
  border: none;
}

.vgt-wrap__footer {
  border: none;
}

.footer__row-count__label,
.footer__row-count__select {
  display: none !important;
}
</style>
